export const america = {
  id: "america",
  shapes: [
    {
      path: "M86.3223 18.7519C86.5134 19.094 86.2076 19.8352 85.9401 20.5194C85.6917 21.1846 86.2458 21.8878 86.9529 21.8117C87.7364 21.7167 88.5199 22.0588 88.9594 22.705L90.5073 24.9476C90.641 25.1377 90.6793 25.3847 90.6219 25.5938L90.2015 27.2282C90.0678 27.7034 90.4691 28.1595 90.9659 28.1025C91.5774 28.0264 92.1698 27.7794 92.6476 27.3993L95.9917 24.8146C96.0108 24.8146 96.0108 24.7956 96.0299 24.7956L100.463 20.7094C100.502 20.6714 100.521 20.6334 100.559 20.5954L102.393 17.2125C102.508 17.0224 102.68 16.8704 102.909 16.8134L108.489 15.369C108.642 15.331 108.757 15.236 108.795 15.0839L111.184 8.37508C111.318 8.03298 111.662 7.80492 112.025 7.84293L115.044 8.14702C115.312 8.16602 115.56 8.33707 115.675 8.56513L118.407 13.7726C118.579 14.0956 118.503 14.4757 118.254 14.7228L113.936 18.7899C113.84 18.8849 113.783 19.018 113.802 19.151L114.184 23.5792C114.203 23.8453 114.088 24.1114 113.878 24.2824L109.407 27.7034C109.311 27.7794 109.235 27.8934 109.235 28.0264L108.967 31.4284C108.948 31.6944 108.795 31.9225 108.585 32.0555L106.846 33.1198C106.731 33.1769 106.674 33.2909 106.636 33.4049L105.814 37.415C105.795 37.51 105.814 37.6241 105.852 37.7001L108.088 41.9953C108.241 42.2803 108.203 42.6224 107.993 42.8695L104.113 47.5638L104.094 47.5828L97.96 55.9071C97.8645 56.0401 97.8454 56.1921 97.9027 56.3442L100.635 62.7679C100.654 62.8059 100.674 62.863 100.674 62.901L102.451 70.9592C102.508 71.2633 102.413 71.5673 102.164 71.7574C102.011 71.8714 101.82 71.9284 101.629 71.9284H98.1893C97.9218 71.9284 97.6543 71.7954 97.5205 71.5673L93.947 66.0748C93.8897 65.9988 93.8706 65.9228 93.8323 65.8278L93.2208 63.3761C93.1826 63.205 93.0489 63.091 92.8769 63.053L88.4626 62.1027C88.4434 62.1027 88.4434 62.1027 88.4243 62.1027L82.5195 61.3805C82.4239 61.3615 82.3284 61.3806 82.2328 61.4376L78.8313 63.4521C78.7931 63.4711 78.7549 63.4901 78.7167 63.5091L75.1241 64.8585C75.0094 64.8965 74.8948 64.9155 74.7801 64.9155L66.9834 64.3074C66.8687 64.3074 66.7732 64.3264 66.6776 64.3834L61.3461 68.2414C61.2314 68.3174 61.155 68.4505 61.155 68.6025L61.1741 73.1828C61.1741 73.4488 61.0403 73.6959 60.8301 73.848C60.6964 73.943 60.5244 74 60.3715 74C60.2759 74 60.1804 73.981 60.0848 73.943L55.3457 72.1755C55.1546 72.0995 55.0017 71.9664 54.9062 71.7764L51.7531 65.3716C51.7149 65.2766 51.6384 65.2006 51.5429 65.1626L48.2178 63.6992C48.0649 63.6232 47.8738 63.6612 47.7401 63.7752L46.3642 64.9535C46.1922 65.1056 45.9629 65.1626 45.7336 65.1436C45.5042 65.1056 45.3132 64.9915 45.1794 64.8015L42.0836 60.4113C42.0454 60.3543 41.9881 60.3163 41.9308 60.2782L35.7966 56.9333C35.7393 56.8953 35.6628 56.8763 35.5864 56.8763H29.0891C28.9362 56.8763 28.8025 56.8383 28.6687 56.7623L20.9484 52.011C20.9102 51.992 20.8529 51.954 20.7956 51.954L15.6169 50.9467C15.4449 50.9087 15.2729 50.8137 15.1582 50.6806L9.73113 44.4279C9.65469 44.3519 9.61647 44.2569 9.57825 44.1618L7.41887 37.8521C7.39976 37.8141 7.39976 37.7761 7.38065 37.7381L6.34874 31.8845C6.34874 31.8655 6.34874 31.8655 6.34874 31.8465L5.50792 25.8789C5.48881 25.7648 5.50792 25.6508 5.52702 25.5368L7.03668 20.5194C7.05579 20.4814 7.05579 20.4624 7.0749 20.4244L11.0497 10.3136C11.0688 10.2566 11.0879 10.1806 11.0879 10.1236L10.763 5.10618C10.7439 4.82111 10.8777 4.53603 11.1261 4.38399C11.3746 4.23195 11.6803 4.21294 11.9478 4.34598L14.4703 5.67634C14.6996 5.79037 14.9863 5.69535 15.1009 5.44828L15.5022 4.49802C15.6551 4.13692 16.0564 3.92786 16.4386 4.02289L26.2227 6.49356C26.2418 6.49356 26.2418 6.49356 26.2609 6.49356L37.5738 8.43209H37.5929L50.7212 9.95251C50.7403 9.95251 50.7403 9.95251 50.7594 9.95251L64.4609 10.3896C64.5565 10.3896 64.652 10.4086 64.7476 10.4466L67.1172 11.4349C67.1745 11.4539 67.2318 11.4729 67.2892 11.4729L69.3721 11.5109C69.4676 11.5109 69.5632 11.5299 69.6396 11.5679L72.0283 12.4612C72.0665 12.4802 72.1239 12.4802 72.1621 12.4802L74.8374 12.5752C75.1241 12.5942 75.3725 12.7463 75.5063 12.9743C75.64 13.2214 75.64 13.5065 75.5063 13.7535L75.3343 14.0766C75.1432 14.4377 75.5063 14.8558 75.8885 14.7038L77.9714 13.8866C78.2963 13.7726 78.6402 13.8486 78.8696 14.1146L80.1308 15.559C80.2454 15.6921 80.4174 15.7491 80.5894 15.6921L83.5514 14.8749C83.7807 14.8178 84.0291 14.8558 84.2202 14.9889L86.3223 18.7519Z",
      fill: "#D6E3F0",
      strokeLinejoin: "round"
    }
  ]
};

// eslint-disable-next-line
export const play = {
  id: "play",
  shapes: [
    {
      path: "M9.99998 19.0664C15.0072 19.0664 19.0664 15.0072 19.0664 9.99998C19.0664 4.99275 15.0072 0.933594 9.99998 0.933594C4.99275 0.933594 0.933594 4.99275 0.933594 9.99998C0.933594 15.0072 4.99275 19.0664 9.99998 19.0664ZM7.18748 14.3598V5.62914L14.075 10.0064L7.18748 14.3598Z",
      fillRule: "evenodd",
      fill: null,
      strokeWidth: 1.5
    }
  ]
};

export const trash = {
  id: "trash",
  shapes: [
    {
      path: "M2.99995 4.25L3.90785 13.352C3.96017 13.8621 4.38985 14.25 4.90263 14.25H11.0973C11.61 14.25 12.0397 13.8621 12.0921 13.352L13 4.25H10.5H5.49995H2.99995Z",
      fill: null,
      strokeWidth: 0,
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    {
      path: "M6.49995 6V12.25M9.49995 6V12.25M2.99995 4.25H5.49995M2.99995 4.25H1M2.99995 4.25L3.90785 13.352C3.96017 13.8621 4.38985 14.25 4.90263 14.25H11.0973C11.61 14.25 12.0397 13.8621 12.0921 13.352L13 4.25M13 4.25H10.5M13 4.25H15M10.5 4.25H5.49995M10.5 4.25V2.75C10.5 2.19772 10.0522 1.75 9.49995 1.75H6.49995C5.94767 1.75 5.49995 2.19772 5.49995 2.75V4.25",
      fill: null,
      strokeWidth: 1.5
    }
  ]
};

export const repeat = {
  id: "repeat",
  shapes: [
    {
      path: "M9.16068 2.74744C11.4249 2.74744 14.25 4.4967 14.25 7.99998C14.25 11.5033 11.4249 13.2525 9.16068 13.2525H6.83944C4.65301 13.2525 1.75 11.5033 1.75 7.99998C1.75 4.4967 4.57526 2.74744 6.83944 2.74744H9.16068Z",
      fill: null,
      strokeWidth: 0,
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    {
      path: "M4 2.74746L6.21161 0.535828M4 2.74746L6.21161 4.95907M4 2.74746H9.16056C11.4247 2.74746 14.25 4.49672 14.25 8.00001C14.25 8.74763 14.1178 9.41537 13.8886 10.0033M12 13.2526L9.78839 11.0409M12 13.2526L9.78839 15.4642M12 13.2526H6.83932C4.57513 13.2526 1.75 11.5033 1.75 8.00001C1.75 7.2561 1.87739 6.59129 2.09974 6.00552",
      fill: null,
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    }
  ]
};

export const question = {
  id: "question",
  shapes: [
    {
      path: "M15.2501 8.00276C15.2501 12.007 12.0041 15.2531 7.99983 15.2531C3.99559 15.2531 0.749512 12.007 0.749512 8.00276C0.749512 3.99852 3.99559 0.752441 7.99983 0.752441C12.0041 0.752441 15.2501 3.99852 15.2501 8.00276Z",
      fill: null,
      strokeWidth: 0
    },
    {
      path: "M7.99982 12V10.5M5.99982 5.99997C5.99982 5.99997 5.99982 3.99997 7.99982 3.99997C9.99982 3.99997 9.99982 5.99997 9.99982 5.99997C9.99982 7.99997 7.99982 7.49997 7.99982 9.49997M15.2501 8.00276C15.2501 12.007 12.0041 15.2531 7.99983 15.2531C3.99559 15.2531 0.749512 12.007 0.749512 8.00276C0.749512 3.99852 3.99559 0.752441 7.99983 0.752441C12.0041 0.752441 15.2501 3.99852 15.2501 8.00276Z",
      fill: null,
      strokeWidth: 1.5
    }
  ]
};

export const info = {
  id: "info",
  shapes: [
    {
      path: "M15.2504 8.00276C15.2504 12.007 12.0043 15.2531 8.0001 15.2531C3.99586 15.2531 0.749786 12.007 0.749786 8.00276C0.749786 3.99852 3.99586 0.752441 8.0001 0.752441C12.0043 0.752441 15.2504 3.99852 15.2504 8.00276Z",
      fill: null,
      strokeWidth: 0
    },
    {
      path: "M8.00009 12V6.99997M8.00009 5.49997V3.99997M15.2504 8.00276C15.2504 12.007 12.0043 15.2531 8.0001 15.2531C3.99586 15.2531 0.749786 12.007 0.749786 8.00276C0.749786 3.99852 3.99586 0.752441 8.0001 0.752441C12.0043 0.752441 15.2504 3.99852 15.2504 8.00276Z",
      fill: null,
      strokeWidth: 1.5
    }
  ]
};

export const infoOutline = {
  id: "infoOutline",
  shapes: [
    {
      path: "M977.017 512.177c0 256.271-207.749 464.02-464.02 464.02-256.271 0-464.02-207.749-464.02-464.02 0-256.272 207.749-464.02 464.02-464.02 256.271 0 464.02 207.748 464.02 464.02z",
      fill: null
    },
    {
      path: "M512.997 96.156c-229.762 0-416.02 186.259-416.02 416.021 0 229.761 186.258 416.02 416.02 416.02 229.762 0 416.02-186.259 416.02-416.02 0-229.762-186.258-416.02-416.02-416.02zM.977 512.177C.977 229.396 230.216.157 512.997.157c282.781 0 512.023 229.239 512.023 512.02 0 282.781-229.242 512.023-512.023 512.023C230.216 1024.2.977 794.958.977 512.177zm560.019-256.179v96h-96v-96h96zm0 192v320h-96v-320h96z",
      fill: null,
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ]
};

export const betCanceled = {
  id: "betCanceled",
  shapes: [
    {
      path: "M12.25 1.75H3.75C3.19772 1.75 2.75 2.19772 2.75 2.75V14.5L5 13.5L6.5 14.5L8 13.5L9.5 14.5L11 13.5L13.25 14.5V2.75C13.25 2.19772 12.8023 1.75 12.25 1.75Z",
      fill: null,
      strokeWidth: 0
    },
    {
      path: "M8 13.5L6.5 14.5L5 13.5L2.75 14.5V2.75C2.75 2.19772 3.19772 1.75 3.75 1.75H12.25C12.8023 1.75 13.25 2.19772 13.25 2.75V8M5 5.75H8M5 8.75H9M10.5 9.5L13 12M13 12L15.5 14.5M13 12L10.5 14.5M13 12L15.5 9.5",
      fill: null,
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    }
  ]
};

export const key = {
  id: "key",
  shapes: [
    {
      path: "M2.86982 14.1147C4.43099 15.6759 6.95866 15.6759 8.51983 14.1147C9.64129 12.9932 9.95956 11.3781 9.46983 9.97469L14.2498 5.19469L14.2498 2.73468L11.7956 2.73468L7.00983 7.51469C5.60873 7.02998 3.9886 7.34592 2.86983 8.46469C1.30866 10.0259 1.30865 12.5535 2.86982 14.1147ZM5.68982 12.0447C6.10352 12.0447 6.43982 11.7084 6.43982 11.2947C6.43982 10.881 6.10352 10.5447 5.68982 10.5447C5.27611 10.5447 4.93982 10.881 4.93982 11.2947C4.93982 11.7084 5.27612 12.0447 5.68982 12.0447Z",
      fill: null,
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeWidth: 0
    },
    {
      path: "M10.6805 6.97898L10.6805 8.57088M12.3339 5.44859L12.3339 6.97898M2.86983 8.46469C1.30866 10.0259 1.30865 12.5535 2.86982 14.1147C4.43099 15.6759 6.95866 15.6759 8.51983 14.1147C9.64129 12.9932 9.95956 11.3781 9.46983 9.97469L14.2498 5.19469L14.2498 2.73468L11.7956 2.73468L7.00983 7.51469C5.60873 7.02998 3.9886 7.34592 2.86983 8.46469ZM6.43982 11.2947C6.43982 11.7084 6.10352 12.0447 5.68982 12.0447C5.27612 12.0447 4.93982 11.7084 4.93982 11.2947C4.93982 10.881 5.27612 10.5447 5.68982 10.5447C6.10352 10.5447 6.43982 10.881 6.43982 11.2947Z",
      fill: null,
      strokeWidth: 1.5
    }
  ]
};

export const optedIn = {
  id: "optedIn",
  shapes: [
    {
      path: "M8.43448 2.25195H13.2484C13.8007 2.25195 14.2484 2.69967 14.2484 3.25195V8.06592C14.2484 8.34424 14.1325 8.60997 13.9284 8.79921L7.79696 14.4844C7.40275 14.8499 6.79008 14.8384 6.40993 14.4582L2.04216 10.0905C1.66202 9.71032 1.65046 9.09765 2.01598 8.70343L7.70119 2.57203C7.89043 2.36794 8.15616 2.25195 8.43448 2.25195Z",
      fill: null,
      strokeWidth: 0
    },
    {
      path: "M5.99992 7.5L7.99992 9.5L11.9999 5.5M13.2484 2.25195H8.43448C8.15616 2.25195 7.89043 2.36794 7.70119 2.57203L2.01598 8.70343C1.65046 9.09765 1.66202 9.71032 2.04216 10.0905L6.40993 14.4582C6.79008 14.8384 7.40275 14.8499 7.79696 14.4844L13.9284 8.79921C14.1325 8.60997 14.2484 8.34424 14.2484 8.06592V3.25195C14.2484 2.69967 13.8007 2.25195 13.2484 2.25195Z",
      fill: null,
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    }
  ]
};

export const referFriend = {
  id: "referFriend",
  shapes: [
    {
      path: "M4.84685 8.99805H11.153C11.8295 8.99805 12.4223 9.45084 12.6002 10.1035L13.3874 12.991C13.5609 13.6271 13.082 14.254 12.4226 14.254H3.57723C2.91789 14.254 2.43901 13.6271 2.61244 12.991L3.39967 10.1035C3.57761 9.45084 4.17038 8.99805 4.84685 8.99805Z",
      fill: null,
      strokeWidth: 0
    },
    {
      path: "M10.5015 4.247C10.5015 5.62848 9.38156 6.74839 8.00008 6.74839C6.6186 6.74839 5.49868 5.62848 5.49868 4.247C5.49868 2.86552 6.6186 1.74561 8.00008 1.74561C9.38156 1.74561 10.5015 2.86552 10.5015 4.247Z",
      fill: null
    },
    {
      path: "M8.50003 14.2544H3.57735C2.91801 14.2544 2.43913 13.6275 2.61256 12.9914L3.39979 10.1038C3.57773 9.45119 4.1705 8.9984 4.84698 8.9984H8.50003M9.75 12.0002H15.2031M12.75 9.50021L15.25 12.0002L12.75 14.5002M10.5015 4.247C10.5015 5.62848 9.38156 6.74839 8.00008 6.74839C6.6186 6.74839 5.49868 5.62848 5.49868 4.247C5.49868 2.86552 6.6186 1.74561 8.00008 1.74561C9.38156 1.74561 10.5015 2.86552 10.5015 4.247Z",
      fill: null,
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    }
  ]
};

export const doubleArrowRight = {
  id: "doubleArrowRight",
  shapes: [
    {
      path: "M10 4.27466L16.25 10.5247L10 16.7747M3.75 4.27466L10 10.5247L3.75 16.7747",
      fill: null,
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    }
  ]
};

export const successDouble = {
  id: "success",
  shapes: [
    {
      path: "M15.2501 8.00276C15.2501 12.007 12.0041 15.2531 7.99983 15.2531C3.99559 15.2531 0.749512 12.007 0.749512 8.00276C0.749512 3.99852 3.99559 0.752441 7.99983 0.752441C12.0041 0.752441 15.2501 3.99852 15.2501 8.00276Z",
      fill: null
    },
    {
      path: "M4.49988 7.99997L6.99988 10.5L11.9999 5.49997M15.2501 8.00276C15.2501 12.007 12.0041 15.2531 7.99983 15.2531C3.99559 15.2531 0.749512 12.007 0.749512 8.00276C0.749512 3.99852 3.99559 0.752441 7.99983 0.752441C12.0041 0.752441 15.2501 3.99852 15.2501 8.00276Z",
      fill: null,
      strokeColor: "#329A47",
      strokeWidth: 1.5
    }
  ]
};

export const lock = {
  id: "lock",
  shapes: [
    {
      path: "M11.25 7.73621V4.7431C11.25 4.7431 11.25 1.75 8 1.75C4.75 1.75 4.75 4.7431 4.75 4.7431V7.73621",
      fill: "#ffffff",
      strokeColor: "#384048",
      strokeWidth: 1.5
    },
    {
      xRect: 2.75,
      yRect: 7.73633,
      widthRect: 10.5,
      heightRect: 6.51379,
      rxRect: 1,
      fill: "#DEE1E3",
      strokeColor: "#384048",
      strokeWidth: 1.5
    },
    {
      path: "M8 10V12",
      fill: null,
      strokeColor: "#384048",
      strokeWidth: 1.5
    }
  ]
};

export const file = {
  id: "file",
  shapes: [
    {
      path: "M3 2H10V5H13V13H3V2Z",
      fill: "#DEE1E3"
    },
    {
      path: "M11 13.5H3.75C3.19772 13.5 2.75 13.0523 2.75 12.5V5.25M13.25 13V10.75V5.5L9.75 2H2M9.75 2.05339V5.5H13.198",
      fill: null,
      strokeColor: "#384048",
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    },
    {
      path: "M1 1L15 15",
      fill: null,
      strokeColor: "#384048",
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    }
  ]
};

export const chevronUp = {
  id: "chevronUp",
  shapes: [
    {
      path: "M3 10.0493L8 5.04932L13 10.0493",
      fill: null,
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    }
  ]
};

export const chevronDown = {
  id: "chevronDown",
  shapes: [
    {
      path: "M13 6L8 11L3 6",
      fill: null,
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    }
  ]
};

export const chevronRight = {
  id: "chevronRight",
  shapes: [
    {
      path: "M5 3L10 8L5 13",
      fill: null,
      strokeColor: "#626D78",
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    }
  ]
};

export const arrowForward = {
  id: "arrowForward",
  shapes: [
    {
      path: "M12.1895 8.74999H2.00012C1.72398 8.74999 1.50012 8.52613 1.50012 8.24999V7.74999C1.50012 7.47384 1.72398 7.24999 2.00012 7.24999H12.1895L8.82334 3.88386C8.62808 3.6886 8.62808 3.37202 8.82334 3.17676L9.17689 2.8232C9.37216 2.62794 9.68874 2.62794 9.884 2.8232L14.5304 7.46965C14.8233 7.76254 14.8233 8.23742 14.5304 8.53031L9.884 13.1768C9.68874 13.372 9.37216 13.372 9.17689 13.1768L8.82334 12.8232C8.62808 12.6279 8.62808 12.3114 8.82334 12.1161L12.1895 8.74999Z",
      fill: null
    }
  ]
};

export const close = {
  id: "close",
  shapes: [
    {
      path: "M3.50012 3.5L12.5001 12.5M12.5001 3.5L3.50012 12.5",
      fill: null,
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    }
  ]
};

export const successRound = {
  id: "successRound",
  shapes: [
    {
      path: "M15.2505 8.00276C15.2505 12.007 12.0044 15.2531 8.00013 15.2531C3.99589 15.2531 0.749817 12.007 0.749817 8.00276C0.749817 3.99852 3.99589 0.752441 8.00013 0.752441C12.0044 0.752441 15.2505 3.99852 15.2505 8.00276Z",
      fill: null,
      strokeWidth: 0
    },
    {
      path: "M4.50018 7.99997L7.00018 10.5L12.0002 5.49997M15.2505 8.00276C15.2505 12.007 12.0044 15.2531 8.00013 15.2531C3.99589 15.2531 0.749817 12.007 0.749817 8.00276C0.749817 3.99852 3.99589 0.752441 8.00013 0.752441C12.0044 0.752441 15.2505 3.99852 15.2505 8.00276Z",
      fill: null,
      strokeWidth: 1.5
    }
  ]
};

export const errorRound = {
  id: "errorRound",
  shapes: [
    {
      path: "M15.2505 8.00276C15.2505 12.007 12.0044 15.2531 8.00013 15.2531C3.99589 15.2531 0.749817 12.007 0.749817 8.00276C0.749817 3.99852 3.99589 0.752441 8.00013 0.752441C12.0044 0.752441 15.2505 3.99852 15.2505 8.00276Z",
      fill: null,
      strokeWidth: 0
    },
    {
      path: "M5.00018 4.99997L8.00018 7.99997M8.00018 7.99997L11.0002 11M8.00018 7.99997L5.00018 11M8.00018 7.99997L11.0002 4.99997M15.2505 8.00276C15.2505 12.007 12.0044 15.2531 8.00013 15.2531C3.99589 15.2531 0.749817 12.007 0.749817 8.00276C0.749817 3.99852 3.99589 0.752441 8.00013 0.752441C12.0044 0.752441 15.2505 3.99852 15.2505 8.00276Z",
      fill: null,
      strokeWidth: 1.5
    }
  ]
};

export const exclamationMarkRound = {
  id: "exclamationMarkRound",
  shapes: [
    {
      path: "M7.29302 1.21052C7.68354 0.819999 8.3167 0.82 8.70723 1.21052L14.7896 7.29287C15.1801 7.68339 15.1801 8.31656 14.7896 8.70708L8.70723 14.7894C8.3167 15.1799 7.68354 15.1799 7.29302 14.7894L1.21067 8.70708C0.820149 8.31656 0.82015 7.68339 1.21067 7.29287L7.29302 1.21052Z",
      fill: null,
      strokeWidth: 0
    },
    {
      path: "M8.00012 8.99997L8.00012 4.49997M8.00012 11.5L8.00012 9.99997M1.21067 8.70708L7.29302 14.7894C7.68354 15.1799 8.3167 15.1799 8.70723 14.7894L14.7896 8.70708C15.1801 8.31656 15.1801 7.68339 14.7896 7.29287L8.70723 1.21052C8.3167 0.82 7.68354 0.819999 7.29302 1.21052L1.21067 7.29287C0.820149 7.68339 0.820149 8.31656 1.21067 8.70708Z",
      fill: null,
      strokeWidth: 1.5
    }
  ]
};

export const exclamationMark = {
  id: "exclamationMark",
  shapes: [
    {
      path: "M15.2503 8.00279C15.2503 12.007 12.0043 15.2531 8.00001 15.2531C3.99577 15.2531 0.749695 12.007 0.749695 8.00279C0.749695 3.99855 3.99577 0.752472 8.00001 0.752472C12.0043 0.752472 15.2503 3.99855 15.2503 8.00279Z",
      fill: null
    },
    {
      path: "M8 9V4M8 12V10.5M15.2503 8.00279C15.2503 12.007 12.0043 15.2531 8.00001 15.2531C3.99577 15.2531 0.749695 12.007 0.749695 8.00279C0.749695 3.99855 3.99577 0.752472 8.00001 0.752472C12.0043 0.752472 15.2503 3.99855 15.2503 8.00279Z",
      fill: null,
      strokeWidth: 1.5
    }
  ]
};

export const questionMarkRound = {
  id: "questionMarkRound",
  shapes: [
    {
      path: "M15.2501 8.00276C15.2501 12.007 12.0041 15.2531 7.99983 15.2531C3.99559 15.2531 0.749512 12.007 0.749512 8.00276C0.749512 3.99852 3.99559 0.752441 7.99983 0.752441C12.0041 0.752441 15.2501 3.99852 15.2501 8.00276Z",
      fill: null,
      strokeWidth: 0
    },
    {
      path: "M7.99982 12V10.5M5.99982 5.99997C5.99982 5.99997 5.99982 3.99997 7.99982 3.99997C9.99982 3.99997 9.99982 5.99997 9.99982 5.99997C9.99982 7.99997 7.99982 7.49997 7.99982 9.49997M15.2501 8.00276C15.2501 12.007 12.0041 15.2531 7.99983 15.2531C3.99559 15.2531 0.749512 12.007 0.749512 8.00276C0.749512 3.99852 3.99559 0.752441 7.99983 0.752441C12.0041 0.752441 15.2501 3.99852 15.2501 8.00276Z",
      fill: null,
      strokeWidth: 1.5
    }
  ]
};

export const scratchedBox = {
  id: "scratchedBox",
  shapes: [
    {
      path: "M0 1a1 1 0 011-1h18a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1z",
      strokeWidth: 0,
      fill: "transparent"
    },
    {
      path: "M.972 20H19a1 1 0 001-1V1a1 1 0 00-1-1H1a1 1 0 00-1 1v18.027A1 1 0 00.972 20zM17.38 1.5H1.5v15.879L17.379 1.5zM2.5 18.5h16v-16l-16 16z",
      strokeWidth: 0,
      fill: null,
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  ]
};

export const userTick = {
  id: "userTick",
  shapes: [
    {
      path: "M4.84685 8.99829H11.153C11.8295 8.99829 12.4223 9.45109 12.6002 10.1037L13.3874 12.9912C13.5609 13.6274 13.082 14.2543 12.4226 14.2543H3.57723C2.91789 14.2543 2.43901 13.6274 2.61244 12.9912L3.39967 10.1037C3.57761 9.45109 4.17038 8.99829 4.84685 8.99829Z",
      strokeWidth: 0,
      fill: "#DEE1E3"
    },
    {
      path: "M10.5014 4.24676C10.5014 5.62824 9.38144 6.74815 7.99996 6.74815C6.61847 6.74815 5.49856 5.62824 5.49856 4.24676C5.49856 2.86527 6.61847 1.74536 7.99996 1.74536C9.38144 1.74536 10.5014 2.86527 10.5014 4.24676Z",
      strokeWidth: 0,
      fill: "#DEE1E3"
    },
    {
      path: "M8.49991 14.2541H3.57723C2.91789 14.2541 2.43901 13.6272 2.61244 12.9911L3.39967 10.1036C3.57761 9.45095 4.17038 8.99815 4.84685 8.99815H8.49991M9.49988 12L11.4999 14L15.4999 9.99996M10.5014 4.24676C10.5014 5.62824 9.38144 6.74815 7.99996 6.74815C6.61847 6.74815 5.49856 5.62824 5.49856 4.24676C5.49856 2.86527 6.61847 1.74536 7.99996 1.74536C9.38144 1.74536 10.5014 2.86527 10.5014 4.24676Z",
      fill: null,
      strokeColor: "#384048",
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    }
  ]
};

// viewBoxSize 32
export const cup = {
  id: "cup",
  shapes: [
    {
      path: "M8.50001 3.5H23.5001L23.5 7C23.5 7 23.5 7.17955 23.4907 7.5C23.4519 8.82849 23.2524 12.5786 22.226 15.9965C21.1996 19.4143 19.3463 22.5 16 22.5C12.6537 22.5 10.8004 19.4143 9.77399 15.9965C8.74756 12.5786 8.54808 8.82849 8.50931 7.5C8.49995 7.17955 8.49995 7 8.49995 7L8.50001 3.5Z",
      clipRule: "evenodd",
      fillRule: "evenodd",
      fill: "#ECEDEE"
    },
    {
      path: "M16 22.5L16 28.5M16 22.5C12.6537 22.5 10.8004 19.4143 9.77399 15.9965M16 22.5C19.3463 22.5 21.1996 19.4143 22.226 15.9965M8.49995 7L8.50001 3.5H23.5001L23.5 7C23.5 7 23.5 7.17955 23.4907 7.5M8.49995 7C8.49995 7 8.49997 11.7541 9.77399 15.9965M8.49995 7C8.49995 7 8.49995 7.17955 8.50931 7.5M16 28.5H9.99995M16 28.5H22M8.50931 7.5H3.49995C3.49995 7.5 3.49995 15.8018 9.77399 15.9965M8.50931 7.5C8.54808 8.82849 8.74756 12.5786 9.77399 15.9965M22.226 15.9965C28.5 15.8018 28.5 7.5 28.5 7.5H23.4907M22.226 15.9965C23.2524 12.5786 23.4519 8.82849 23.4907 7.5",
      strokeColor: "#818A92",
      strokeWidth: 2,
      strokeLinejoin: "round",
      fill: null
    }
  ]
};

export const warning = {
  id: "warning",
  shapes: [
    {
      path: "M1.82179 14.25H14.1775C14.5524 14.25 14.794 13.8527 14.6214 13.5198L8.44387 1.606C8.25732 1.24622 7.74269 1.24621 7.55612 1.60598L1.37792 13.5198C1.20532 13.8527 1.44687 14.25 1.82179 14.25Z",
      fill: null
    },
    {
      path: "M8.00002 6V10M8.00002 11V12.5M7.55612 1.60598L1.37792 13.5198C1.20532 13.8527 1.44687 14.25 1.82179 14.25H14.1775C14.5524 14.25 14.794 13.8527 14.6214 13.5198L8.44387 1.606C8.25732 1.24622 7.74269 1.24621 7.55612 1.60598Z",
      fill: null,
      strokeColor: "",
      strokeWidth: 1.5
    }
  ]
};

export const announcements = {
  id: "announcements",
  shapes: [
    {
      path: "M21.375 6.15001V17.85M21.375 6.15001V3M21.375 6.15001L4.55169 8.59275C3.44554 8.75337 2.625 9.70165 2.625 10.8194V13.1806C2.625 14.2984 3.44554 15.2467 4.55169 15.4073M21.375 17.85V21M21.375 17.85L13.875 16.761M21.375 17.85L4.55169 15.4073M5.625 15.5631V19.875H13.875V16.761M5.625 15.5631L4.55169 15.4073M5.625 15.5631L13.875 16.761",
      fill: null,
      strokeColor: "#5390ED",
      strokeWidth: 2
    }
  ]
};

export const bell = {
  id: "bell",
  shapes: [
    {
      path: "M8.04184 9.5H4.04184H1L1.54977 8.18073C1.87307 7.40492 1.99063 6.56185 2.0538 5.72376C2.18661 3.96205 2.88002 1 6.04181 1C9.25134 1 9.9174 4.05217 10.0355 5.80272C10.0886 6.59026 10.1885 7.38276 10.471 8.1198L11 9.5H8.04184Z",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "white",
      fillOpacity: 0.1
    },
    {
      path: "M8.04184 9.5H11L10.471 8.1198C10.1885 7.38276 10.0886 6.59026 10.0355 5.80272C9.9174 4.05217 9.25134 1 6.04181 1C2.88002 1 2.18661 3.96205 2.0538 5.72376C1.99063 6.56185 1.87307 7.40492 1.54977 8.18073L1 9.5H4.04184M8.04184 9.5V10C8.04184 11.1046 7.14641 12 6.04184 12C4.93727 12 4.04184 11.1046 4.04184 10V9.5M8.04184 9.5H4.04184",
      fill: null,
      strokeWidth: 1.5,
      strokeLinejoin: "round",
      strokeColor: "#818A92"
    }
  ]
};

export const crossedBell = {
  id: "crossedBell",
  shapes: [
    {
      path: "M1 1L15 15M12.4791 9.25L12.4292 9.1198C12.1467 8.38276 12.0468 7.59026 11.9937 6.80272C11.8756 5.05217 11.2095 2 8 2C7.17748 2 6.52201 2.20046 6 2.52809M4.48091 4.5C4.18574 5.26496 4.06104 6.07454 4.01211 6.72219C3.9488 7.56028 3.83126 8.40492 3.50796 9.18073L2.95819 10.5H6M6 10.5V11C6 12.1046 6.89543 13 8 13C9.10457 13 10 12.1046 10 11L10 10.5H6Z",
      fill: null,
      strokeColor: "#5390ED",
      strokeWidth: 1.5,
      strokeLinejoin: "round"
    }
  ]
};
